'use client';

import React from 'react';
import { Box, Container } from '@mui/material';
import { Outlet } from 'react-router-dom';

export default function ClaimsLayout() {
  return (
    <Box>
      {/* Nested routes (Claims list / details) will render here */}
      <Outlet />
    </Box>
  );
} 